import { defaultFill } from '../../utils/constants';
var muiPrinterOutline16 = {
    paths: [
        {
            path: 'M12.0046024,0 C12.5543453,0 13,0.437881351 13,1.00292933 L13,3 L15.0001925,3 C15.5523709,3 16,3.45303631 16,3.99703014 L16,10.0029699 C16,10.5536144 15.5553691,11 14.9991283,11 L13,11 L13,13.0001925 C13,13.5523709 12.5443356,14 12.0046024,14 L3.99539757,14 C3.44565467,14 3,13.5562834 3,13.0001925 L3,10.999 L1.00087166,11 C0.448105505,11 0,10.5469637 0,10.0029699 L0,3.99703014 C1.77635684e-15,3.4463856 0.443716645,3 0.999807492,3 L3,3 L3,1.00292933 C3,0.449026756 3.4556644,-8.8817842e-16 3.99539757,-8.8817842e-16 L12.0046024,0 Z M11,11 L5,11 L5,12 L11,12 L11,11 Z M3,5 L2,5 L2,9 L14,9 L14,5 L13,5 L13,7 L3,7 L3,5 Z M11,2 L5,2 L5,5 L11,5 L11,2 Z',
            fill: defaultFill,
        },
    ],
    title: 'Printer',
    width: 16,
    height: 14,
};
var muiPrinterOutline24 = {
    paths: [
        {
            path: 'M15,8 L8,8 L8,6 L15,6 L15,8 Z M16,3 L16,5 L8,5 L8,3 L16,3 Z M18.9991283,0 C19.5518945,0 20,0.444836974 20,0.995577499 L20,4 L23.009222,4 C23.5564136,4 24,4.45576096 24,5.00247329 L24,14.9975267 C24,15.5511774 23.5525308,16 22.9993054,16 L20,16 L20,19.009222 C20,19.5564136 19.5553691,20 18.9991283,20 L5.00087166,20 C4.4481055,20 4,19.5490248 4,19.009222 L4,16 L1.00069463,16 C0.448026248,16 0,15.544239 0,14.9975267 L0,5.00247329 C0,4.44882258 0.45097518,4 0.990777969,4 L4,4 L4,0.995577499 C4,0.445735229 4.44463086,0 5.00087166,0 L18.9991283,0 Z M2,14 L22,14 L22,6 L20,6 L20,11 L4,11 L4,6 L2,6 L2,14 Z M18,18 L18,16 L6,16 L6,18 L18,18 Z M18,9 L18,2 L6,2 L6,9 L18,9 Z',
            fill: defaultFill,
        },
    ],
    title: 'Printer',
    width: 24,
    height: 20,
};
var muiPrinterOutline = {
    base: muiPrinterOutline16,
    smIcon: muiPrinterOutline16,
    lgIcon: muiPrinterOutline24,
};
export { muiPrinterOutline };
//# sourceMappingURL=printerOutline.js.map